import { useState } from 'react'
import { Icon } from 'packages/eid-icons'
import appConfig from 'config'
import DropdownFilter from './DropdownFilter'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { useQuery } from 'packages/core'
import useConfiguration from 'useConfiguration'
import { SubPathLevel } from 'appConfiguration'
import useSubcomponents from 'useSubcomponents'

const DropdownMenu = ({ currentResourceType, totalCount }) => {
    const { t } = useTranslation()
    const history = useHistory()

    const { resourceTypes } = useConfiguration()
    const { hasAccessToTabs } = useSubcomponents()

    const [open, setOpen] = useState(false)

    const {
        location: { pathname },
    } = history

    const query = useQuery()
    query.delete('selected')

    let subPaths = pathname.split('/')

    const areaName =
        subPaths.length >= SubPathLevel + 2 ? subPaths[2 + SubPathLevel] : ''

    const applicationId = query.get('applicationId')
    const workflowName = query.get('workflowName')

    // Filter out resource types that the user doesn't have access to
    const resourceTypesToShow = resourceTypes.filter((resourceType) => {
        const { hasAccessToAtleastOneTab } = hasAccessToTabs(resourceType.name)
        return hasAccessToAtleastOneTab
    })

    const selectedRoute =
        areaName !== 'applications'
            ? resourceTypesToShow.filter(
                  (r) => r.name === currentResourceType.name,
              )[0]
            : { name: 'applications', title: 'Common_Applications' }

    return (
        <>
            <DropdownFilter
                label={t(
                    selectedRoute ? selectedRoute.title : 'Common_Applications',
                )}
                setOpen={setOpen}
                open={open}
                style={{
                    height: '60px',
                }}
                anchorPosition={{ top: '60px' }}
                totalCount={totalCount}
                showTotalCount={!applicationId && !workflowName}
            >
                {resourceTypesToShow.map((r, index) => (
                    <DropdownFilter.Item
                        selected={r.name === currentResourceType.name}
                        onClick={() => {
                            setOpen((prev) => !prev)
                            if (areaName === 'manageAccess') {
                                let URL = `${appConfig.APP_SUBPATH}${r.route}/manageAccess`
                                history.push(URL)
                            } else {
                                history.push(
                                    `${appConfig.APP_SUBPATH}${r.route}`,
                                )
                            }
                        }}
                        key={r.name + index}
                    >
                        <Icon
                            width="1.6rem"
                            height="1.6rem"
                            name={r.icon.small}
                            color="#919193"
                            style={{ marginRight: '2rem' }}
                        />
                        {t(r.title)}
                    </DropdownFilter.Item>
                ))}
            </DropdownFilter>
        </>
    )
}

export { DropdownMenu }
